module.exports = __webpack_public_path__ + "static/media/music-slash.d367f52d.svg";